import secureLocalStorage from "react-secure-storage";
import { GridCell } from "@progress/kendo-react-grid";
import { TextArea } from "@progress/kendo-react-inputs";
import React from "react";
import "../../Styles/RiskDiscription.scss";

export default class RiskDescriptionCell extends GridCell {
  constructor(props) {
    super(props);
    this.state = {
      temp: this.props.dataItem.name,
    };
  }
  componentDidMount = () => {
    if(this.props.dataItem.inEdit&&document.getElementById("riskdescriptionId")){
        document.getElementById("riskdescriptionId").focus();
    }
  };
  handleChange = (e) => {
    this.setState({ temp: e.value });
  };
  handleBlur = (e) => {
    this.props.handleCellAddValue(this.state.temp);
    this.props.onChange({
      dataItem: this.props.dataItem,
      field: this.props.field,
      syntheticEvent: e.syntheticEvent,
      value: this.state.temp,
    });
    if (
      this.props.field &&
      this.props.field === this.props.dataItem.inEdit &&
      this.props.dataItem.riskRegisterId
    ) {
      let updateData = {
        ...this.props.dataItem,
        name: this.state.temp,
      };
      if (this.state.temp != this.props.dataItem.name) {
        this.props.updateDropdownValue(updateData);
      }
    }
  };
  handleChangeForAdd = (e) => {
    this.props.handleCellAddValue(e.value);
  };
  handleBlurForAdd=(e)=>{
    this.props.onChange({
      dataItem: this.props.dataItem,
      field: this.props.field,
      syntheticEvent: e.syntheticEvent,
      value: e.target.value,
    });
  }
  handleEditCell = () => {
    // if (this.props.dataItem.riskRegisterId) {
    this.props.onEditCell(this.props.dataItem, this.props.field);
    // }
  };
  render() {
    const { dataItem, field } = this.props;
    const loginUserId=parseInt(secureLocalStorage.getItem("loginUserId"));
 const ownerId=dataItem.userId;
    const dataValue =
      dataItem[field] === null || dataItem[field] == undefined
        ? ""
        : dataItem[field];
    if (this.props.field && this.props.field === this.props.dataItem.inEdit) {
      return (
        <td
         style={{left:'547px'}} 
        className="k-grid-content-sticky-temp  inlineEditField">
          {this.props.riskAddOrEdit == true ? (
            <TextArea
            // autoSize={true}
            // style={{width:'100%'}}
              defaultValue={dataValue}
              onChange={(e) => this.handleChangeForAdd(e)}
              onBlur={(e) => this.handleBlurForAdd(e)}
              id="riskdescriptionId"
            />
          ) : (
            <TextArea
              defaultValue={dataValue}
              onChange={(e) => this.handleChange(e)}
              onBlur={this.handleBlur}
              id="riskdescriptionId"
            />
          )}
        </td>
      );
    } else {
      if(loginUserId===ownerId){
        return (
        <td title={dataValue} onClick={this.handleEditCell} style={{left:'547px'}} className="k-grid-content-sticky-temp">
          <p>{dataValue}</p>
        </td>
        )
      }else{
      return this.props.dataItem.role == "Standard User" ||
      this.props.dataItem.role == "View Only" ? (
        <td title={dataValue} style={{left:'547px'}} className="k-grid-content-sticky-temp">
          <p>{dataValue}</p>
        </td>
      ) : (
        <td title={dataValue} onClick={this.handleEditCell} style={{left:'547px'}} className="k-grid-content-sticky-temp">
          <p>{dataValue} </p>
        </td>
      );
      }
    }
  }
}
